import React from "react";

import { Grid } from "gridjs-react";
// import "gridjs/dist/theme/mermaid.css";
import "../../styles/components/Admin/DataGrid.scss";
import MessageBox from "../MessageBox";
import { LoaderState } from "../../redux/reducers/LoaderSlice";
import { useAppSelector } from "../../redux/hooks";

interface DataGridType {
  columnData: string[];
  cellData: any;
  isPagination: boolean;
  paginationLimit: number;
  isPaginationSummary: boolean;
  serverConfig?: any;
  paginationSever?: any;
  sortConfig?: any;
}

const stylesProperties = {
  wrapper: "dataGridContainer",
  table: "dataGridTableStyle",
  th: "dataGridTH",
  td: "dataGridTD",
  tr: "dataGridTR",
  pagination: "dataGridPaginationContainer",
  paginationSummary: "dataGridPaginationSummary",
  paginationButtonNext: "dataGridPaginationButtonNext",
  paginationButtonPrev: "dataGridPaginationButtonPrev",
  paginationButtonCurrent: "dataGridPaginationCurrent",
  paginationButton: "dataGridPaginationButton",
  gridErrorMessage: "gridjs-error",
};

const DataGrid = ({
  columnData,
  cellData,
  isPagination,
  paginationLimit,
  isPaginationSummary,
  paginationSever,
  serverConfig,
  sortConfig,
}: DataGridType) => {
  const paginationData: any = {
    enabled: isPagination,
    limit: paginationLimit,
    summary: isPaginationSummary,
  };

  if (paginationSever) {
    paginationData.server = paginationSever;
  }
  const loader = useAppSelector(LoaderState);
  return (
    <div className="data-table text-capitalize">
      <Grid
        data={cellData}
        columns={columnData}
        className={stylesProperties}
        pagination={paginationData}
        server={serverConfig ? serverConfig : ""}
        sort={sortConfig ? sortConfig : ""}
        language={{
          pagination: {
            previous: "<",
            next: ">",
          },
        }}
      />
      {cellData.length < 1 && (
        <MessageBox
          message_key={loader.loading ? "pcp_loading_msg" : "no_result"}
        />
      )}
    </div>
  );
};
DataGrid.defaultProps = {
  isPagination: false,
  paginationLimit: 10,
  isPaginationSummary: true,
};

export default DataGrid;
